import { IConfig } from '@cian/config/shared';
import { IGeoService } from '../../browser/addform/scripts/services/geoService';

interface IParams {
  config: IConfig;
  geoService: IGeoService;
}

export const isBaseAndProfiFrozen = ({ config, geoService }: IParams) => {
  const isFeatureEnabled = config.getStrict<boolean>('BaseAndProfiTariffsFrozen.Enabled');

  // тарифы заморожены
  return (
    isFeatureEnabled &&
    // тариф пользователя для МиМО или СПбиЛО
    (geoService.isMiMO() || geoService.isSPBAndArea())
  );
};
